// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
// 图表界面
import statistics from '@/views/charts/statistics';




/**
 * 用户管理
 */
//用户列表
import userList from '@/views/user/user';





import series from '@/views/product/series';
import module from '@/views/product/module';
import info from '@/views/product/info';
import content from '@/views/product/content';





import dcate from '@/views/document/dcate';
import dinfo from '@/views/document/dinfo';
import dcomment from '@/views/document/dcomment';





import rcate from '@/views/res/rcate';
import rinfo from '@/views/res/rinfo';





import ccate from '@/views/cou/ccate';
import cinfo from '@/views/cou/cinfo';
import ccomment from '@/views/cou/ccomment';
import log from '@/views/zx/log';


import gs from '@/views/pz/gs';
import huo from '@/views/pz/huo';




/**
 * 系统设置
 * */
//账号管理
import sysUser from '@/views/system/user';
//角色管理
import sysRole from '@/views/system/Role';
//菜单管理
import sysMenu from '@/views/system/menu';
//系统参数配置
import program from '@/views/system/program';
//操作日志
import systemLogList from '@/views/system/systemLogList';






// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
    // mode: "history",
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '/login',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },
      {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/charts/statistics',
            name: '数据统计',
            component: statistics,
            meta: {
                requireAuth: true
            }
        },{
          path: '/user/user',
          name: '用户列表',
          component: userList,
          meta: {
            requireAuth: true
          }
        },{
          path: '/product/series',
          name: '产品系列',
          component: series,
          meta: {
            requireAuth: true
          }
        },{
          path: '/product/module',
          name: '产品模块分类',
          component: module,
          meta: {
            requireAuth: true
          }
        },{
          path: '/product/info',
          name: '产品列表',
          component: info,
          meta: {
            requireAuth: true
          }
        },{
          path: '/product/content',
          name: '产品模块内容',
          component: content,
          meta: {
            requireAuth: true
          }
        },{
          path: '/document/dcate',
          name: '技术文档分类',
          component: dcate,
          meta: {
            requireAuth: true
          }
        },{
          path: '/document/dinfo',
          name: '技术文档列表',
          component: dinfo,
          meta: {
            requireAuth: true
          }
        },{
          path: '/document/dcomment',
          name: '评论管理',
          component: dcomment,
          meta: {
            requireAuth: true
          }
        },{
          path: '/res/rcate',
          name: '产品手册分类',
          component: rcate,
          meta: {
            requireAuth: true
          }
        },{
          path: '/res/rinfo',
          name: '产品手册列表',
          component: rinfo,
          meta: {
            requireAuth: true
          }
        },{
          path: '/cou/ccate',
          name: '课程标签',
          component: ccate,
          meta: {
            requireAuth: true
          }
        },{
          path: '/cou/cinfo',
          name: '课程列表',
          component: cinfo,
          meta: {
            requireAuth: true
          }
        },{
          path: '/cou/ccomment',
          name: '评论管理',
          component: ccomment,
          meta: {
            requireAuth: true
          }
        },{
          path: '/zx/log',
          name: '咨询管理日志',
          component: log,
          meta: {
            requireAuth: true
          }
        },{
          path: '/pz/gs',
          name: '公司设置',
          component: gs,
          meta: {
            requireAuth: true
          }
        },{
          path: '/pz/huo',
          name: '火花设置',
          component: huo,
          meta: {
            requireAuth: true
          }
        },{
          path: '/system/user',
          name: '账号管理',
          component: sysUser,
          meta: {
            requireAuth: true
          }
        },{
          path: '/system/menu',
          name: '菜单管理',
          component: sysMenu,
          meta: {
            requireAuth: true
          }
        },{
          path: '/system/Role',
          name: '角色管理',
          component: sysRole,
          meta: {
            requireAuth: true
          }
        },{
          path: '/system/program',
          name: '系统参数配置',
          component: program,
          meta: {
            requireAuth: true
          }
        },{
          path: '/system/systemLogList',
          name: '操作日志',
          component: systemLogList,
          meta: {
            requireAuth: true
          }
        }

        ]
    }]
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace (location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}







// WEBPACK FOOTER //
// ./src/router/index.js